
// import { useState, useMemo } from "react";
// import StepLayout from "./StepLayout";
// import NavFooter from "./NavFooter";
// import styles from "./StepQuestionnaire.module.css";

// import { SYMPTOM_QUESTIONS } from "./const";


// function ScaleInput({ value, onChange, options }) {
//   return (
//     <div className={styles.scaleWrap}>
//       <div className={styles.scaleOptions}>
//         {options.map((opt) => (
//           <button
//             key={opt.value}
//             className={`${styles.scaleOption} ${
//               value === opt.value ? styles.scaleOptionActive : ""
//             }`}
//             onClick={() => onChange(opt.value)}
//           >
//             {opt.label}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// }

// /* ── Question Card ── */
// function QuestionCard({ q, value, onChange, index }) {
//   return (
//     <div className={styles.card}>
//       <div className={styles.cardTopRow}>
//         <p className={styles.cardQuestion}>{q.question}</p>
//         <span className={styles.cardIndex}>Q{index}</span>
//       </div>

//       {q.type === "single" && (
//         <div className={styles.options}>
//           {q.options.map((opt) => (
//             <button
//               key={opt}
//               className={`${styles.option} ${value === opt ? styles.optionSelected : ""}`}
//               onClick={() => onChange(value === opt ? null : opt)}
//             >
//               {opt}
//             </button>
//           ))}
//         </div>
//       )}

//       {q.type === "multi" && (
//         <div className={styles.options}>
//           {q.options.map((opt) => {
//             const arr = Array.isArray(value) ? value : [];
//             const isOn = arr.includes(opt);
//             return (
//               <button
//                 key={opt}
//                 className={`${styles.option} ${isOn ? styles.optionSelected : ""}`}
//                 onClick={() => {
//                   const arr2 = Array.isArray(value) ? [...value] : [];
//                   if (isOn) onChange(arr2.filter((x) => x !== opt));
//                   else onChange([...arr2, opt]);
//                 }}
//               >
//                 {opt}
//               </button>
//             );
//           })}
//         </div>
//       )}

//       {q.type === "scale" && (
//         <ScaleInput {...q} value={value} onChange={onChange} />
//       )}
//     </div>
//   );
// }

// /* ── MAIN ── */
// export default function StepQuestionnaire({ symptoms, initial, onNext, onBack }) {
//   const [answers, setAnswers] = useState(initial || {});
//   const [step, setStep] = useState(0);

//   /* Build groups */
//   const groups = useMemo(() => {
//     const seen = new Set();
//     const g = [];

//     g.push({
//       label: "General",
//       icon: "📝",
//       questions: SYMPTOM_QUESTIONS.default.filter((q) => {
//         if (seen.has(q.id)) return false;
//         seen.add(q.id);
//         return true;
//       }),
//     });

//     (symptoms || []).forEach((sym) => {
//       const qs = SYMPTOM_QUESTIONS[sym.label];
//       if (!qs) return;

//       const unique = qs.filter((q) => {
//         if (seen.has(q.id)) return false;
//         seen.add(q.id);
//         return true;
//       });

//       if (unique.length) {
//         g.push({ label: sym.label, icon: "🔍", questions: unique });
//       }
//     });

//     return g;
//   }, [symptoms]);

//   const currentGroup = groups[step];

//   /* Save answer */
//   const setAnswer = (id, value) =>
//     setAnswers((prev) => ({ ...prev, [id]: value }));

//   /* Validation per step */
//   const isStepComplete = currentGroup.questions.every((q) => {
//     const v = answers[q.id];
//     return v !== null && v !== undefined && (Array.isArray(v) ? v.length > 0 : true);
//   });

//   /* Navigation */
//   const handleNext = () => {
//     if (step < groups.length - 1) {
//       setStep(step + 1);
//     } else {
//       onNext(answers);
//     }
//   };

//   const handleBack = () => {
//     if (step === 0) {
//       onBack?.();
//     } else {
//       setStep(step - 1);
//     }
//   };

//   /* Progress */
//   const pct = Math.round(((step + 1) / groups.length) * 100);

//   console.log({ step, pct });

//   return (
//     <StepLayout
//       title="Symptom Questionnaire"
//       subtitle="Step-by-step questions for better diagnosis"
//       icon="❓"
//       footer={
//         <NavFooter
//           onBack={handleBack}
//           onNext={handleNext}
//           nextLabel={step === groups.length - 1 ? "Finish" : "Save & Next"}
//           disableNext={!isStepComplete}
//         />
//       }
//     >
//       {/* Step Progress */}
//       <div className={styles.stepper}>
//         {groups.map((g, i) => (
//           <div key={i} className={`${styles.step} ${i === step ? styles.stepActive : ""}`}>
//             {g.label}
//           </div>
//         ))}
//       </div>

//       {/* Progress Bar */}
//       <div className={styles.progressTrack}>
//         <div className={styles.progressFill} style={{ width: `${pct}%` }} />
//       </div>

//       {/* Current Group */}
//       <div className={styles.group}>
//         <div className={styles.groupTitle}>
//           <span>{currentGroup.icon}</span>
//           {currentGroup.label}
//         </div>

//         <div className={styles.cards}>
//           {currentGroup.questions.map((q, idx) => (
//             <QuestionCard
//               key={q.id}
//               q={q}
//               value={answers[q.id]}
//               onChange={(v) => setAnswer(q.id, v)}
//               index={idx + 1}
//             />
//           ))}
//         </div>
//       </div>
//     </StepLayout>
//   );
// }


import { useState, useMemo } from "react";
import StepLayout from "./StepLayout";
import NavFooter from "./NavFooter";
import PatientCard from "./PatientCard";
import styles from "./StepQuestionnaire.module.css";
import { SYMPTOM_QUESTIONS } from "./const";

/* ---------- SCALE ---------- */
function ScaleInput({ value, onChange, options }) {
  return (
    <div className={styles.scaleWrap}>
      <div className={styles.scaleOptions}>
        {options.map((opt) => (
          <button
            key={opt.value}
            className={`${styles.scaleOption} ${
              value === opt.value ? styles.scaleOptionActive : ""
            }`}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

/* ---------- QUESTION ---------- */
function QuestionCard({ q, value, onChange, index, error }) {
  return (
    <div className={`${styles.card} ${error ? styles.cardError : ""}`}>
      <div className={styles.cardTopRow}>
        <p className={styles.cardQuestion}>{q.question}</p>
        <span className={styles.cardIndex}>Q{index}</span>
      </div>

      {q.type === "single" && (
        <div className={styles.options}>
          {q.options.map((opt) => (
            <button
              key={opt}
              className={`${styles.option} ${
                value === opt ? styles.optionSelected : ""
              }`}
              onClick={() => onChange(value === opt ? null : opt)}
            >
              {opt}
            </button>
          ))}
        </div>
      )}

      {q.type === "multi" && (
        <div className={styles.options}>
          {q.options.map((opt) => {
            const arr = Array.isArray(value) ? value : [];
            const isOn = arr.includes(opt);
            return (
              <button
                key={opt}
                className={`${styles.option} ${
                  isOn ? styles.optionSelected : ""
                }`}
                onClick={() => {
                  const arr2 = Array.isArray(value) ? [...value] : [];
                  if (isOn) onChange(arr2.filter((x) => x !== opt));
                  else onChange([...arr2, opt]);
                }}
              >
                {opt}
              </button>
            );
          })}
        </div>
      )}

      {q.type === "scale" && (
        <ScaleInput {...q} value={value} onChange={onChange} />
      )}

      {error && <p className={styles.errorText}>Please select an option</p>}
    </div>
  );
}

/* ---------- MAIN ---------- */
export default function StepQuestionnaire({
  symptoms,
  patient,
  initial,
  onNext,
  onBack,
}) {
  const [answers, setAnswers] = useState(initial || {});
  const [groupIndex, setGroupIndex] = useState(0);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [showError, setShowError] = useState(false);

  /* Build groups */
  const groups = useMemo(() => {
    const seen = new Set();
    const g = [];

    // g.push({
    //   label: "General",
    //   icon: "📝",
    //   questions: SYMPTOM_QUESTIONS.default.filter((q) => {
    //     if (seen.has(q.id)) return false;
    //     seen.add(q.id);
    //     return true;
    //   }),
    // });

    (symptoms || []).forEach((sym) => {
      const qs = SYMPTOM_QUESTIONS[sym.label];
      if (!qs) return;

      const unique = qs.filter((q) => {
        if (seen.has(q.id)) return false;
        seen.add(q.id);
        return true;
      });

      if (unique.length) {
        g.push({ label: sym.label, icon: "🔍", questions: unique });
      }
    });

    return g;
  }, [symptoms]);

  const currentGroup = groups[groupIndex];
  const currentQuestion = currentGroup.questions[questionIndex];
  const value = answers[currentQuestion.id];

  /* Save answer */
  const setAnswer = (id, value) => {
    setAnswers((prev) => ({ ...prev, [id]: value }));
    setShowError(false);
  };

  /* Validation */
  const isAnswered =
    value !== null &&
    value !== undefined &&
    (Array.isArray(value) ? value.length > 0 : true);

  /* NEXT */
  const handleNext = () => {
    if (!isAnswered) {
      setShowError(true);
      return;
    }

    if (questionIndex < currentGroup.questions.length - 1) {
      setQuestionIndex((prev) => prev + 1);
      return;
    }

    if (groupIndex < groups.length - 1) {
      setGroupIndex((prev) => prev + 1);
      setQuestionIndex(0);
      return;
    }

    onNext(answers);
  };

  /* BACK */
  const handleBack = () => {
    if (questionIndex > 0) {
      setQuestionIndex((prev) => prev - 1);
      return;
    }

    if (groupIndex > 0) {
      const prevGroup = groups[groupIndex - 1];
      setGroupIndex((prev) => prev - 1);
      setQuestionIndex(prevGroup.questions.length - 1);
      return;
    }

    onBack?.();
  };

  /* Progress */
  const totalQuestions = groups.reduce(
  (sum, g) => sum + g.questions.length,
  0
);

const currentFlatIndex =
  groups.slice(0, groupIndex).reduce((sum, g) => sum + g.questions.length, 0) +
  questionIndex ;
console.log(currentFlatIndex,"this is the currentflat index")
const pct = Math.round((currentFlatIndex / totalQuestions) * 100);
console.log(pct,totalQuestions,"pccccccccct")
console.log()
// console.log({ currentFlatIndex, totalQuestions, pct });

  /* -------- RIGHT SIDE DATA -------- */
  const storedHistory = JSON.parse(
    localStorage.getItem("medicalHistory") || "{}"
  );

  const mapPreScreenToHistory = (data) => {
    if (!data) return {};
    return {
      condition:
        data.hasCondition === "Yes"
          ? data.diagnosed || true
          : false,
      takingMeds: data.takingMeds === "Yes",
      allergy: data.hasAllergy,
      surgery:
        data.hasSurgery === "Yes"
          ? data.surgeryWhen || true
          : false,
    };
  };

  const historyData = mapPreScreenToHistory(storedHistory);

  return (
    <div className="syptom-layout">
    <StepLayout
      title="Symptom Questionnaire"
      subtitle="Step-by-step questions for better diagnosis"
      icon="❓"
      footer={
        <NavFooter
          onBack={handleBack}
          onNext={handleNext}
          nextLabel={
            currentFlatIndex === totalQuestions ? "Finish" : "Continue"
          }
        />
      }
    >
      <div className={styles.wrapper}>

        {/* LEFT SIDE */}
        <div className={styles.left}>


          

          <div className={styles.stepper}>
            {groups.map((g, i) => (
              <div
                key={i}
                className={`${styles.step} ${
                  i === groupIndex ? styles.stepActive : ""
                }`}
              >
                {g.label}
              </div>
            ))}
          </div>


          <div className={styles.progressTrack}>
            <div className={styles.progressFill} style={{ width: `${pct}%` }} />
          </div>

          {/* QUESTION */}
          <div className={styles.group}>
            <div className={styles.groupTitle}>
              <span>{currentGroup.icon}</span>
              {currentGroup.label}
            </div>

            <QuestionCard
              q={currentQuestion}
              value={value}
              onChange={(v) =>
                setAnswer(currentQuestion.id, v)
              }
              index={currentFlatIndex}
              error={showError}
            />
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className={styles.right}>
          <PatientCard patient={patient} size={130} />

          <div className={styles.historyCard}>
            <h4 className={styles.historyTitle}>
              Medical History
            </h4>

            <ul className={styles.historyList}>
              {Object.entries(historyData).length > 0 ? (
                Object.entries(historyData).map(
                  ([key, value], i) => {
                    let label = "";
                    let icon = "?";

                    switch (key) {
                      case "condition":
                        label =
                          value && value !== true
                            ? `Diagnosed with ${value}`
                            : "Has medical condition";
                        icon = value ? "✔" : "✖";
                        break;

                      case "takingMeds":
                        label =
                          "Currently taking medications";
                        icon = value ? "✔" : "✖";
                        break;

                      case "allergy":
                        label = "Has allergies";
                        icon =
                          value === "Yes"
                            ? "✔"
                            : value === "No"
                            ? "✖"
                            : "?";
                        break;

                      case "surgery":
                        label =
                          value && value !== true
                            ? `Surgery: ${value}`
                            : "Past surgery";
                        icon = value ? "✔" : "✖";
                        break;

                      default:
                        label = key;
                    }

                    return (
                      <li
                        key={i}
                        className={styles.historyItem}
                      >
                        <span
                          className={styles.historyDot}
                        >
                          {icon}
                        </span>
                        {label}
                      </li>
                    );
                  }
                )
              ) : (
                <li className={styles.historyEmpty}>
                  No history available
                </li>
              )}
            </ul>
          </div>
        </div>

      </div>
    </StepLayout>
    </div>
  );
}